import { CfAsset } from '../asset';

export function mapCfEntityToCfLink(cfEntity = {}) {
    const { fields } = cfEntity;

    const { text, link, linkAbTest, internal, icon, click_class: trackingClass } = fields || {};

    return {
        label: text,
        internal: Boolean(internal),
        icon: icon && CfAsset.mapCfEntity(icon),
        url: link,
        alternativeURL: linkAbTest,
        trackingClass,
    };
}
